import { COLOR_BASE_GREY_40, COLOR_BASE_GREY_5 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { zIndexHeadline } from '~/styles/tokens';

export const SliderCatalogueHeadlineStyle = styled.div<{ spaceBetween: number }>`
	display: none;
	position: sticky;
	color: ${COLOR_BASE_GREY_40};
	top: 0;
	right: 0;
	z-index: ${zIndexHeadline};
	flex-direction: row;
	padding-top: ${(props) => props.spaceBetween / 2}px;
	padding-bottom: ${(props) => props.spaceBetween / 3}px;
	background-color: ${COLOR_BASE_GREY_5};

	&.visible {
		display: flex;
	}

	.asLink {
		cursor: pointer;
	}
`;

export const SliderCatalogueSectionHeadlineStyle = styled.span`
	padding-left: 8px;
`;

export const SliderCatalogueCloser = styled.span`
	margin-left: auto;
`;
